import { useRouteError } from "react-router-dom";

const RouteErrorBoundary = () => {
  const error = useRouteError();
  throw error;
};

export default RouteErrorBoundary;
